import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { media } from '@atlaskit/primitives';

import { Picture } from '@/components/wpl/image/src/image';
import { wacToken } from '@/libraries/design/foundations';
import { Row } from '@/libraries/wpl/foundations/src/grid';

const sectionStyle = css({
	marginBlockEnd: '4rem',
	textAlign: 'center',
	color: wacToken('color.extended.blue1000'),
});

const logosGridStyle = css({
	display: 'grid',
	gap: '2rem',
	gridTemplateColumns: 'minmax(160px, 1fr)',
	placeItems: 'center',
	margin: 'auto',
	padding: 0,
	listStyle: 'none',
	width: '100%',

	// Unable to target img styling via Picture component `css` prop
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	img: {
		maxWidth: '100%',
	},
	[media.only.sm]: {
		gridTemplateColumns: 'repeat(3, minmax(160px, 1fr))',
	},
	[media.above.md]: {
		gridTemplateColumns: 'repeat(6, 1fr)',
	},
});

const liStyle = css({
	margin: 0,
});

const Customers = () => {
	const logos = [
		{
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/260w4830ha12g7838ik7j5rq3ex31h8h.svg',
			alt: 'Canva',
			width: 136,
			height: 43,
		},
		{
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4ojx82fmj7q6l0354r1qfe572un65j0m.svg',
			alt: 'Coupa',
			width: 158,
		},
		{
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g76770b7kmwx457yu43qbo42h874ann8.svg',
			alt: 'Docker',
			width: 158,
		},
		{
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7ivn8866tpd7e4155176u71d4syycwc8.webp',
			alt: 'The Economist',
			width: 112,
		},
		{
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4x7bp61gn38200m4omcfxsx0cm75w71i.svg',
			alt: 'Deliveroo',
			width: 148,
		},
		{
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mmi427i07l27j8ul2aj32h25144vb65u.svg',
			alt: 'Decathlon',
			width: 156,
		},
	];

	return (
		<div css={sectionStyle}>
			<Row layout="12">
				<h2 className="h5">
					<FormattedMessage
						id="JiraProductDiscoveryPage.customers.heading"
						defaultMessage="Join the 10,000+ customers who build products with Jira Product Discovery"
					/>
				</h2>
			</Row>
			<Row layout="12">
				<ul css={logosGridStyle}>
					{logos.map((logo) => (
						<li key={logo.src} css={liStyle}>
							<Picture image={{ ...logo }} />
						</li>
					))}
				</ul>
			</Row>
		</div>
	);
};

export default Customers;
